import React from 'react';

import ReactEcharts from 'echarts-for-react';

import useThemeColorMode from '@qality/common-utils/src/hooks/useThemeColorMode';

import { registerEChartsThemes } from '../ChartThemes';

const radiusLevel = [
  [[0, '80%']],
  [
    [0, '40%'],
    ['40%', '80%'],
  ],
  [
    [0, '26%'],
    ['26%', '52%'],
    ['52%', '80%'],
  ],
  [
    [0, '20%'],
    ['20%', '40%'],
    ['40%', '60%'],
    ['60%', '80%'],
  ],
];

export interface PieChartProps {
  height?: number;
  seriesData?: {
    name: string;
    data: {
      name: string;
      stack?: string;
      data: number[];
    }[];
  }[];
}

registerEChartsThemes();

export const PieChart: React.FC<PieChartProps> = ({
  height,
  seriesData = [],
}: PieChartProps) => {
  const themeColorMode = useThemeColorMode();
  const radiusLevels = radiusLevel[seriesData.length - 1] || radiusLevel[0];

  const getTooltipFormatter = (params) => {
    const { name, value, percentage } = params.data;
    return `${name}: <b>${value}</b> (${percentage}%)`;
  };

  const echartsOptionConfig = {
    tooltip: {
      trigger: 'item',
      formatter: getTooltipFormatter,
    },
    legend: {
      orient: 'vertical',
      left: 'left',
    },
    series: seriesData.map((serieData, idx) => ({
      type: 'pie',
      radius: radiusLevels[idx],
      emphasis: {
        itemStyle: {
          shadowBlur: 10,
          shadowOffsetX: 0,
          shadowColor: 'rgba(0, 0, 0, 0.5)',
        },
      },
      label: {
        show: true,
        formatter: '{b}: {c} ({d}%)',
        fontSize: 12,
      },
      ...serieData,
    })),
  };

  return (
    <ReactEcharts
      style={{ height }}
      option={echartsOptionConfig}
      theme={themeColorMode}
    />
  );
};
